/* Change this file to get your personal Portfolio */

// Your Summary And Greeting Section

import emoji from "react-easy-emoji";

const greeting = {
  username: "Omar Kantroo",
  title: "Hi all, I'm Omar",
  subTitle: emoji(
    "Senior developer 💻 with 5+ years of experience in TypeScript, FastAPI, and .NET. Skilled in AWS, PostgreSQL, MongoDB, and AI-driven workflows. Experienced in integrating OpenAI APIs and building chatbots using n8n and modern web stacks."
  ),
  resumeLink: "https://github.com/metheok/CV/raw/master/omarKantroo_cv.pdf",
};

// Your Social Media Link
const cvLinks = {
  cvLink1: "https://github.com/metheok/CV/raw/master/omarKantroo_cv.pdf",
};
const socialMediaLinks = {
  github: "https://github.com/metheok",
  linkedin: "https://www.linkedin.com/in/okantroo/",
  telegram: "https://t.me/iamomariqbal",
  gmail: "studentinok@gmail.com",
  // gitlab: "https://gitlab.com/metheok",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@metheok",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta"
  // Instagram and Twitter are also supported in the links!
};

// Your Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "FULL STACK DEVELOPER EXPLORING AI, AUTOMATION, AND MODERN WEB STACKS",
  skills: [
    emoji(
      "⚡ Develop, maintain and deploy full-fledged webapps using JavaScript, TypeScript, and modern frameworks"
    ),
    emoji(
      "⚡ Design fast and scalable SPAs with solid backend integrations and cloud deployment"
    ),
    emoji(
      "⚡ Build AI-powered chatbots and workflow automations using OpenAI API and n8n"
    ),
  ],

  softwareSkills: [
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5",
    },
    {
      skillName: "n8n (Workflow Automation)",
      fontAwesomeClassname: "fas fa-project-diagram",
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js",
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fas fa-code",
    },
    {
      skillName: "ReactJS",
      fontAwesomeClassname: "fab fa-react",
    },
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-angular",
    },
    {
      skillName: "ASP.NET Core",
      fontAwesomeClassname: "fas fa-code",
    },
    {
      skillName: "NodeJS",
      fontAwesomeClassname: "fab fa-node",
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws",
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-database",
    },
    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "fas fa-database",
    },
    {
      skillName: "OpenAI API",
      fontAwesomeClassname: "fas fa-robot",
    },
  ],
};

// Your top 3 work experiences

const workExperiences = {
  viewExperiences: true,
  experience: [
    {
      role: "Web Developer",
      company: "Web Artisans",
      websiteLink: "https://www.webartisans.dev/",
      companylogo: require("./assets/images/webArtisans.jfif"),
      date: "December 2021 – Present",
      desc: "Service-based company creating marketplaces and custom solutions. Worked on technologies like ReactJS, Angular, FastAPI, NestJS, TypeScript, PostgreSQL, Redux, NodeJS, ExpressJS, and MongoDB. Also integrated OpenAI APIs and n8n workflows for automation and chat-based features.",
    },
    {
      role: "Full Stack Developer",
      company: "Possier",
      websiteLink: "https://www.possier.com/",
      companylogo: require("./assets/images/possier-logo.jfif"),
      date: "February 2021 – November 2021",
      desc: "Developed and maintained restaurant-specific ERP-POS products. Focused on performance and UI/UX optimization across the stack.",
    },
    {
      role: "Software Developer",
      company: "ITS - Internet Travel Solutions",
      websiteLink: "https://www.its.com/",
      companylogo: require("./assets/images/its-logo.png"),
      date: "October 2020 – February 2021",
      desc: "Contributed to full-stack development and maintenance of travel management systems and online booking products.",
    },
    {
      role: "Web Developer (Front End and Backend)",
      company: "ITenzyme",
      websiteLink: "https://www.itenzyme.in/",
      companylogo: require("./assets/images/ITenzymeLogo.jpg"),
      date: "June 2015 – Present",
      desc: "Over 6+ years in web design and development, collaborating with startups and product-based companies. Recently explored AI-driven integrations and automation pipelines using OpenAI and n8n.",
    },
  ],
};

const openSource = {
  githubConvertedToken:
    "NmFiMWU1NDk3NDIyNzIxYmJiZTgxZDAyMGI4MjllMjRlN2IxMjQxZQ==",
  githubUserName: "metheok",
  showGithubProfile: "false",
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project, AI automation, or just want to say hi? My inbox is open.",
  twitter: "https://twitter.com/iamomariqbal",
  location: "Kashmir, India",
  telegram: "https://t.me/iamomariqbal",
  email_address: "studentinok@gmail.com",
};

export {
  greeting,
  cvLinks,
  socialMediaLinks,
  skillsSection,
  workExperiences,
  openSource,
  contactInfo,
};
